export default "__VITE_ASSET__f9ee1c77__"